import Hero from '../components/about/Hero';
import Solutions from '../components/about/Solutions';
import Features from '../components/about/Features';
import Founder from '../components/about/Founder';
import Contact from '../components/home/Contact';

function About() {
  return (
    <>
      <Hero />
      <Solutions />
      <Features />
      <Contact />
    </>
  );
}

export default About;
